import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';

const BASIS_TRANSCODER_PATH = '/basis/';

let sharedKtx2Loader = null;
let sharedKtx2Gl = null;

/**
 * Один экземпляр KTX2Loader на WebGL-контекст (требование three.js).
 * @param {import('three').WebGLRenderer} gl
 * @returns {KTX2Loader|null}
 */
export function getSharedKtx2Loader(gl) {
  if (!gl) {
    return null;
  }
  if (sharedKtx2Loader && sharedKtx2Gl !== gl) {
    sharedKtx2Loader.dispose();
    sharedKtx2Loader = null;
    sharedKtx2Gl = null;
  }
  if (!sharedKtx2Loader) {
    sharedKtx2Loader = new KTX2Loader();
    sharedKtx2Loader.setTranscoderPath(BASIS_TRANSCODER_PATH);
    sharedKtx2Loader.detectSupport(gl);
    sharedKtx2Gl = gl;
  }
  return sharedKtx2Loader;
}
